// extracted by mini-css-extract-plugin
export default {"root":"NumberRangeFilterPopup_root__NUq5j marketplaceTinyFontStyles","popupSize":"NumberRangeFilterPopup_popupSize__bcsRl"};